export class BarcodeScanned {

    constructor(data) {
        this.data = data;
        this.type = data.type;
        this.id = data.id;
        this.stock_id = data.stock_id;
    }

}